module.exports = __webpack_public_path__ + "img/dog.d966d077.png";